export { MomentsPage as Moments } from './Moments';
